import {
  MAX_AGENT_TIMEOUT_SECONDS,
  MIN_AGENT_TIMEOUT_SECONDS,
} from "@frontend-shared/constants";

export const AGENT_RUNS_PER_PAGE = 20;
export const WEBHOOK_RUNS_PER_PAGE = 20;
export const HOOK_RUNS_PER_PAGE = 20;

export const MAX_INTERVAL_MINUTES = 1440;
export const MAX_INTERVAL_HOURS = 720;
// NOTE: NSAI-6655 — the server's bounds, shared with mobile.
export const MAX_TIMEOUT_SECONDS = MAX_AGENT_TIMEOUT_SECONDS;
export const MIN_TIMEOUT_SECONDS = MIN_AGENT_TIMEOUT_SECONDS;

export const RUNNING_POLL_INTERVAL_MS = 10_000;

export const AGENTS_RUNS_QUERY_PARAM = "runs";
